import { render } from "./FluxRss.vue?vue&type=template&id=be4fc7b2&scoped=true"
import script from "./FluxRss.vue?vue&type=script&lang=js"
export * from "./FluxRss.vue?vue&type=script&lang=js"

import "./FluxRss.vue?vue&type=style&index=0&id=be4fc7b2&scoped=true&lang=css"

import exportComponent from "/Users/macbook13dbs1/Documents/Vue/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be4fc7b2"]])

export default __exports__